export default {
      id: "icon-hand-with-coins-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-hand-with-coins",
      toString: function () {
        return this.url;
      }
    }